export interface HighScore {
  initials:string; score:number; level:number; date:string; homes:number; startLives:3|5|7;
  mode:'ORIGINAL ARCADE'|'ADVANCED';
}
export function validateHighScore(value:unknown):HighScore|null{
  if(!value||typeof value!=='object')return null;
  const v=value as Partial<HighScore>;
  if(typeof v.score!=='number'||!Number.isFinite(v.score)||v.score<0)return null;
  const lives=v.startLives===5?5:v.startLives===7?7:3;
  return {initials:typeof v.initials==='string'?v.initials.toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,3).padEnd(3,'A'):'AAA',
    score:Math.floor(v.score),level:Math.max(1,Math.floor(Number(v.level)||1)),homes:Math.max(0,Math.floor(Number(v.homes)||0)),
    date:typeof v.date==='string'&&!Number.isNaN(Date.parse(v.date))?v.date:new Date(0).toISOString(),startLives:lives,mode:lives===3?'ORIGINAL ARCADE':'ADVANCED'};
}
export function ranked(scores:HighScore[]):HighScore[]{return [...scores].sort((a,b)=>b.score-a.score||b.level-a.level||b.homes-a.homes||a.date.localeCompare(b.date)).slice(0,10);}
